import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { useTranslation } from 'react-i18next'
import { showAlert } from '../../../utility/SweetAlert'
import { useDispatch } from 'react-redux'
import { FetchAccount } from '../../../redux/account/actionCreator'
import { HideLoading, ShowLoading } from '../../../redux/loading/actionCreator'
import { ACCOUNT_NOT_VERIFIED, DATA_NOT_EXIST } from '../../../utility/ResponseConstant'
import { InteractorStoreAccountView } from '../../Main'
import { setCookies } from '../../../utility/Cookies'
import { encryptCrypto } from '../../../utility/Encryption'

const InteractorAccountUserLogin = () => {
  const { t } = useTranslation()
  const { viewAccount } = InteractorStoreAccountView()
  const dispatch = useDispatch()

  const login = useCallback(
    async (payload) => {
      dispatch(ShowLoading())
      payload = {
        ...payload,
        access_user_agent: navigator?.userAgent,
        access_ip_address: null,
        access_location: null,
        access_device: null,
      }
      ApiService.jsonRequest('/account-user/login', payload, (response) => {
        if (response.status_code === 200) {
          setCookies({
            key: '_wsso',
            value: encryptCrypto(JSON.stringify(response.data)),
            expires: new Date().getTime() + 8 * 3600 * 1000, // 8 Hours
          })
          dispatch(FetchAccount(response.data))
          viewAccount({
            uid: '',
            account_uid: response.data.uid,
          })
        } else {
          switch (response.messages) {
            case ACCOUNT_NOT_VERIFIED:
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 2000,
              })
              break
            case DATA_NOT_EXIST:
              showAlert({
                icon: 'error',
                message: t(`response_message.user_not_found`),
                timer: 2000,
              })
              break
            default:
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 2000,
              })
              break
          }
          dispatch(HideLoading())
        }
      })
    },
    [dispatch, t, viewAccount],
  )

  return { login }
}

export default InteractorAccountUserLogin
